


































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ADD_CONTACT } from '../store';
import ContactCombobox from '@/modules/contact/components/ContactCombobox.vue';
import { ConservatorshipDetails } from '../../conservatorship/types';
import { WriteContact } from '../types';
import { ApiResponse } from '@/components/types';
import { createContact } from '@/modules/conservatorshipToContact/model';
import { Contact } from '@/modules/contact/types';
import ContactTypeSelect from '@/modules/contact/components/ContactTypeSelect.vue';

const Conservatorship = namespace('conservatorshipToContact');

@Component({
  components: {
    ContactTypeSelect,
    ContactCombobox
  }
})
export default class AddContactDialog extends Vue {
  @Prop({ type: Object, required: true }) conservatorship!: ConservatorshipDetails;
  @Conservatorship.Action(ADD_CONTACT) addContact!: (params: WriteContact) => Promise<ApiResponse>;

  dialog: boolean = false;
  error: any = null;
  disabled: boolean = false;

  value = createContact(this.conservatorship.id, []);

  @Watch('dialog')
  watchDialogClosed(dialog: boolean) {
    if (dialog) {
      this.value = createContact(this.conservatorship.id, []);
      this.disabled = false;

      return;
    }

    setTimeout(() => {
      this.error = null;
      // @ts-ignore
      this.$refs.form.reset();
    }, 200);
  }

  @Watch('value.name')
  watchName(value: string) {
    if (value) return;

    this.value = createContact(this.conservatorship.id, []);
  }

  sync(contact: Contact) {
    if (!contact) {
      this.value = createContact(this.conservatorship.id, []);
      this.disabled = false;
      return;
    }

    this.value.contact_id = contact.id;
    this.value.name = contact.name;
    this.value.additional = contact.additional;
    this.value.street = contact.street;
    this.value.zip_code = contact.zipCode;
    this.value.city = contact.city;
    this.value.phone_number = contact.phoneNumber;
    this.value.types = [...contact.types];
    this.disabled = true;
  }

  async save() {
    this.error = null;

    return this.addContact(this.value);
  }
}
